import { ModulePermissions, PermissionsPipeData } from "./base-classes";
import * as R from 'ramda'
import { LoggedUser } from "../../../redux/store";
import {Account} from "@idha/idha-types"
import { hasPersonPermission } from "redux/helperFunctions/loggedUser.helperFunctions";

export class OrderAccessPermissions extends ModulePermissions {
    accessOrdersModule: boolean = true
    //putOrder: boolean = true
    manageMyStore: boolean = true
    manageClientOrdersData: boolean = true
    manageProductOrdersData: boolean = true
    accessReceivedOrders? = true
    accessProductsAcquisitionCosts? = true
    accessProductsSalesPrice? = true
    accessProductsPricingConfiguration? = true
    accessStoreConfigurationPricing? = true

    constructor() {
        super();
    }
}


export class OrderPermissionsPipeData extends PermissionsPipeData<OrderAccessPermissions> {


    constructor(loggedUser:LoggedUser,public account:Account){
        super(loggedUser,new OrderAccessPermissions());

    }
}

namespace AccessRules {
    export function isShop(data: OrderPermissionsPipeData) {
        if(!hasPersonPermission(data.loggedUser,'orders-external-shop')){
            //data.permissions.putOrder = false
            data.permissions.manageMyStore = false;
            data.permissions.manageProductOrdersData = false;
            data.permissions.manageClientOrdersData = false;
            data.permissions.accessReceivedOrders = false
            data.permissions.accessProductsAcquisitionCosts = false
            data.permissions.accessProductsSalesPrice = false
            data.permissions.accessProductsPricingConfiguration = false
            data.permissions.accessStoreConfigurationPricing = false
        }
        return data
    }

    export function isClient(data: OrderPermissionsPipeData) {

        if(!data.loggedUser.personInformation.isClient){
          data.permissions.accessOrdersModule = false;
        }
        return data
    }

    export function end(data: OrderPermissionsPipeData) {
        return data.permissions
    }
}

export default R.pipe(
    AccessRules.isShop,
    AccessRules.isClient,
    AccessRules.end
);